// extracted by mini-css-extract-plugin
export default {"mainContainer":"CheckoutComplete_mainContainer__NiB-G","paper":"CheckoutComplete_paper__cLCNa","rightPaper":"CheckoutComplete_rightPaper__fIPdl"};